import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { Icon, ShareFacebookIcon, SharePinterestIcon, ShareTwitterIcon } from "../../../Icon";
import { useShareUrl, windowOpen } from "../../utils";
import styles from "./ShareButton.style";

const getNetworkData = (network) => {
    switch (network) {
        case "facebook":
            return {
                label: "Facebook",
                icon: ShareFacebookIcon,
            };
        case "pinterest":
            return {
                label: "Pinterest",
                icon: SharePinterestIcon,
            };
        case "twitter":
            return {
                label: "Twitter",
                icon: ShareTwitterIcon,
            };
        default:
            return undefined;
    }
};

const ShareButtonStyled = styled.button((props) => ({ ...styles(props) }));

const ShareButton = ({
    network,
    titleAccess,
    url,
    text,
    media,
    windowHeight,
    windowWidth,
    onClick,
    disableShareDialogOnClick,
    disabled,
    className,
    ...rest
}) => {
    const shareUrl = useShareUrl(network, url, text, media);

    if (disabled || !shareUrl) {
        return null;
    }

    const handleClick = (event, ...args) => {
        event.preventDefault();
        if (!disableShareDialogOnClick) {
            windowOpen(shareUrl, windowHeight, windowWidth);
        }

        if (onClick) {
            onClick(event, ...args);
        }
    };

    const getTitleAccess = titleAccess || `Podijeli na ${getNetworkData(network)?.label}`;

    return (
        <ShareButtonStyled
            onClick={handleClick}
            title={getTitleAccess}
            className={className}
            {...rest}
        >
            {getNetworkData(network)?.icon && <Icon icon={getNetworkData(network)?.icon} />}
        </ShareButtonStyled>
    );
};

const shareButtonNetworks = Object.freeze({
    FACEBOOK: "facebook",
    PINTEREST: "pinterest",
    TWITTER: "twitter",
});

ShareButton.propTypes = {
    className: PropTypes.string,
    titleAccess: PropTypes.string,
    network: PropTypes.oneOf([...Object.values(shareButtonNetworks)]),
    url: PropTypes.string,
    text: PropTypes.string,
    media: PropTypes.string,
    windowHeight: PropTypes.number,
    windowWidth: PropTypes.number,
    disableShareDialogOnClick: PropTypes.bool,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

ShareButton.defaultProps = {
    className: undefined,
    titleAccess: undefined,
    network: undefined,
    url: undefined,
    text: undefined,
    media: undefined,
    windowHeight: 400,
    windowWidth: 550,
    disableShareDialogOnClick: false,
    onClick: undefined,
    disabled: false,
};

export { shareButtonNetworks };

export default ShareButton;
